import { Injectable } from '@angular/core';
import { RestfulService } from '@app/service/restful.service';

@Injectable({
  providedIn: 'root'
})
export class InspectionBasicService {

  constructor(
    private restful: RestfulService,
  ) { }

  private extractData(res: Response) {
    let body = res;
    return body || [ ];
  }

  private handleErrorPromise(error: Response | any) {
    console.error(error.message || error);
    return Promise.reject(error.message || error);
  }

  // 시험검사신청관리
  inspectionApplication(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'inspectionApplication'
      }, params
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 시험검사 이력조회 목록 (inspectionApplication CRUD=R 분리)
  getInspectionHistoryList(params: any): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'getInspectionHistoryList'
      }, params
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 품목상세 목록 (CRUD=READINSPECTIONPRODUCT 분리)
  getInspectionProducts(params: any): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'getInspectionProducts'
      }, params
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 신청서 하위데이터 일괄 (CRUD=READSUBDATA, subType 없음)
  getApplicationSubDataAll(params: any): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'getApplicationSubDataAll'
      }, params
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 신청모델 목록 (CRUD=READSUBDATA + modelList)
  getApplicationModels(params: any): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'getApplicationModels'
      }, params
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 의뢰구분 목록 (CRUD=READSUBDATA + request)
  getApplicationRequests(params: any): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'getApplicationRequests'
      }, params
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 개별항목 목록 (CRUD=READSUBDATA + item)
  getApplicationItems(params: any): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'getApplicationItems'
      }, params
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 첨부파일 목록 (CRUD=READSUBDATA + file)
  getApplicationFiles(params: any): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'getApplicationFiles'
      }, params
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 품목별 검사항목 후보 (CRUD=INSPECTIONITEM 분리)
  getInspectionItemCandidates(params: any): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'getInspectionItemCandidates'
      }, params
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 접수번호 수정
  setUpdateReceptionNumber(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'setUpdateReceptionNumber'
      }, params
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 모델별 견적서 정보 가져오기
  getEstimateModelInfo(params: any): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'getEstimateModelInfo'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  // 모델별 견적서 정보 가져오기
  getEstimateItemBasicFee(params: any): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'getEstimateItemBasicFee'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }


  // 견적 총합 저장하기
  setEstimateTotal(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'setEstimateTotal'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  // 시험검사신청관리 목록 (CRUD=R 목록 분리, 쿼리 실패 처리 포함)
  getInspectionApplicationList(search): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'getInspectionApplicationList'
      }, search
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  // 신청서 단건 조회 (CRUD=R + seq 분리)
  getApplication(params: any): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'getApplication'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  // 견적합계 (CRUD=READESTIMATE 분리)
  getEstimate(params: any): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'getEstimate'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  // 견적 수수료 헤더 (CRUD=ESTIMATEFEEHEAD 분리)
  getEstimateFeeHead(params: any): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'getEstimateFeeHead'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  // 견적 후보항목 (CRUD=READESTIMATEITEM 분리)
  getEstimateItemCandidates(params: any): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'getEstimateItemCandidates'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  // 견적 하위데이터 (CRUD=SUBESTIMATE 분리)
  getEstimateSubData(params: any): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'getEstimateSubData'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  // 견적서 생성 (CRUD=CREATEESTIMATE 분리)
  createEstimate(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'createEstimate'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  // 신청서 신규 (CRUD=C 분리)
  createApplication(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'createApplication'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  // 신청서 수정 (CRUD=U 분리)
  updateApplication(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'updateApplication'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  // 신청서 입금여부 변경
  updateApplicationDepositConfirm(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'updateApplicationDepositConfirm'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  // 신청서 복사 (CRUD=W 분리)
  copyApplication(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'copyApplication'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  // 견적 항목 추가 (CRUD=CREATEESTIMATEITEM 분리)
  createEstimateItems(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'createEstimateItems'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  // 견적 항목 수수료 수정 (CRUD=UPDATEITEM 분리)
  updateEstimateItemFee(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'updateEstimateItemFee'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  // 견적 항목 삭제 (CRUD=DELETEITEM 분리)
  deleteEstimateItem(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'deleteEstimateItem'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  // 견적합계 저장 (CRUD=UPDATEESTIMATE 분리)
  updateEstimate(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'updateEstimate'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  // 개별항목 일괄추가 (CRUD=CREATEITEMARRAY 분리)
  createInspectionItems(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'createInspectionItems'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  // 첨부파일 추가 (CRUD=CREATEFILE 분리)
  createApplicationFile(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'createApplicationFile'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  // 적용모델 일괄추가 (CRUD=CREATEMODELARRAY 분리)
  createApplyModels(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'createApplyModels'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  deleteInspectionItems(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'deleteInspectionItems'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  deleteApplicationFile(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'deleteApplicationFile'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  deleteApplyModel(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'deleteApplyModel'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  deleteRequest(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'deleteRequest'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  deleteApplicationModel(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'deleteApplicationModel'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  updateApplyModel(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'updateApplyModel'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  updateApplicationModelList(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'updateApplicationModelList'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  updateRequest(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'updateRequest'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  createRequest(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'createRequest'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  updateRequestByIrgAdd(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'updateRequestByIrgAdd'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  createApplicationModel(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'createApplicationModel'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  updateApplicationModel(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'updateApplicationModel'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  updateRequestAuditResult(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'updateRequestAuditResult'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  updateApplicationStatus(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'updateApplicationStatus'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  updateInspectionItemResults(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'updateInspectionItemResults'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  createApplicationSubData(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'createApplicationSubData'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  // 예비 분리 API (현재 FE 미사용, CRUD 잔여 분리)
  createInspectionItem(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'createInspectionItem'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  createApplicationFiles(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'createApplicationFiles'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  createApplyModel(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'createApplyModel'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  duplicateApplyModels(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'duplicateApplyModels'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  deleteApplication(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'deleteApplication'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  upsertEstimateItem(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'upsertEstimateItem'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  // 검사수수료마스터
  inspectionFeeMaster(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'inspectionFeeMaster'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  inspectionFeeSlave(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'inspectionFeeSlave'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  // 품목별시험검사항목 - 시험검사의뢰구분
  inspectionItemCategoryNew(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'inspectionItemCategoryNew'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  // 품목별시험검사항목 - 시험검사의뢰구분추가
  inspectionItemCategoryNewCreateDisplay(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'inspectionItemCategoryNewCreateDisplay'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  // 단체표준코드관리 - 단체표준코드
  spsCode(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'spsCode'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  // 단체표준코드관리 - 적용품목
  spsCodeItem(params: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'spsCodeItem'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  // 시험검사품목관리 가져오기
  getInspectionProductList(search): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'getInspectionProductList'
      }, search
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 시험검사항목관리 가져오기
  getInspectionItemList(search): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'getInspectionItemList'
      }, search
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 품목별 검사항목 가져오기
  getInspectionItemCategory(search): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'getInspectionItemCategory'
      }, search
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 시험검사품목관리 추가/수정하기
  setInspectionProduct( form ): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'setInspectionProduct'
      }, form.value
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 시험검사품목관리 삭제하기
  setDeleteProduct(seq: any): Promise<any> {
    return this.restful.get({
      program: 'admin',
      service: 'inspectionbasic',
      version: '1.0',
      action: 'setDeleteProduct'
      }, {
        seq: seq
      }
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  // 시험검사항목관리 추가/수정하기
  setInspectionCategory( form ): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'setInspectionCategory'
      }, form.value
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 시험검사항목관리 삭제하기
  setDeleteItemCategory(seq: any): Promise<any> {
    return this.restful.get({
      program: 'admin',
      service: 'inspectionbasic',
      version: '1.0',
      action: 'setDeleteItemCategory'
      }, {
        seq: seq
      }
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  // 시험검사항목관리 순서 저장
  setSortOrderSave( array: any ): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'setSortOrderSave'
      }, {
        params: array
      }
    ).then(this.restful.extractData)
     .catch(this.restful.handleErrorPromise);
  }

  // 시험검사항목관리 순서 저장
  setInspectionCategorySave( array: any ): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'setInspectionCategorySave'
      }, {
        params: array
      }
    ).then(this.restful.extractData)
     .catch(this.restful.handleErrorPromise);
  }

  // 시험검사 수수료관리 마스터 가져오기
  getFeeMaster(): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'getFeeMaster'
      }, {}
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 시험검사 수수료관리 마스터 추가/수정
  setFeeMasterSave( form ): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'setFeeMasterSave'
      }, form.value
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 시험검사 전항목수수료 가져오기
  getAllFeeList(search): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'getAllFeeList'
      }, search
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 시험검사 항목별수수료 가져오기
  getFeeCategory(search): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'getFeeCategory'
      }, search
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 공장 심사 항목 마스터 가져오기
  getInspectionMasterList(): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'getInspectionMasterList'
      }, {}
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  // 실험실이용 신청서 리스트 가져오기
  getLabUseApplicationList( search ): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'getLabUseApplicationList'
      }, search
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  // 실험실이용 신청서 정보 가져오기
  getLabUseApplicationInfo( seq: any ): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'getLabUseApplicationInfo'
      }, {
        seq: seq
      }
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }


  // 실험실 이용신청서 삭제하기
  deleteLabUseApplication(seq: any): Promise<any> {
    return this.restful.get({
      program: 'admin',
      service: 'inspectionApplication',
      version: '1.0',
      action: 'setDeleteLabUseApplication'
      }, {
        seq: seq
      }
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  // 공장 심사 항목 마스터 가져오기
  getInspectionFactoryItemList( search ): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'getInspectionFactoryItemList'
      }, search
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  // 공장 심사 항목 마스터 추가/수정
  setInspectionMaster( form ): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'setInspectionMaster'
      }, form.value
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  // 공장 심사 항목 마스터 삭제
  delInspectionMaster( seq: any ): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'delInspectionMaster'
      }, {
        seq: seq
      }
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  // 공장 심사 항목 추가/수정
  setInspectionItem( form ): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'setInspectionItem'
      }, form.value
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  // 공장 심사 항목 마스터 삭제
  delInspectionItem( seq: any ): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'delInspectionItem'
      }, {
        seq: seq
      }
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  // 공장 심사 항목 마스터 가져오기
  getSpsCheckItemList(): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'getSpsCheckItemList'
      }, {}
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  // 사이즈 순서 저장
  setSortOrder( array: any ): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'setSortOrder'
      }, {
        params: array
      }
    ).then(this.restful.extractData)
      .catch(this.restful.handleErrorPromise);
  }

  // 구비서류 점검표관리 삭제
  deleteCheckItem( seq: any ): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'deleteCheckItem'
      }, {
        seq: seq
      }
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  // 구비서류 점검표 추가/수정
  setCheckItem( form ): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'setCheckItem'
      }, form.value
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  // 회사 정보 가져오기
  getCompanyInfo(seq: any): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'getCompanyInfo'
      }, {seq: seq}
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  // 회사정보 수정
  setCompany( form ): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'setCompany'
      }, form.value
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  // 표준 정보 가져오기
  getSpscodeList(): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'getSpscodeList'
      }, {}
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  // 품목 정보 가져오기
  getInspectionItemCategoryList(seq): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'getInspectionItemCategoryList'
      }, {seq: seq}
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  // 단체표준인증 신청서 가져오기
  getApplicationList( search ): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'getApplicationList'
      }, search
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  // 인증신청서 정보 가져오기
  getApplicationInfo(seq: any): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'getApplicationInfo'
      }, {seq: seq}
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  // 인증신청서 삭제하기
  delApplicationList(seq: any): Promise<any> {
    return this.restful.get({
      program: 'admin',
      service: 'inspectionbasic',
      version: '1.0',
      action: 'delApplicationList'
      }, {
        seq: seq
      }
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  // 인증서 구비서류 저장
  setAddApplicationFile( form: any ): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'setAddApplicationFile'
      }, form.value
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  // 인증신청서 구비서류 가져오기
  getApplicationFile(seq: any): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'getApplicationFile'
      }, {seq: seq}
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  // 인증신청서 구비서류 삭제하기
  delApplicationFile(seq: any): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'delApplicationFile'
      }, {seq: seq}
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  // 인증신청서 구비서류 검토리스트 가져오기
  getApplicationCheckList(seq: any): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'getApplicationCheckList'
      }, {seq: seq}
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  // 구비서류 점검표 검토입력
  setApplicationCheckItem( form ): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'setApplicationCheckItem'
      }, form.value
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  // 단체표준인증 견적서 등록
  setSpsApplicationEstimate( form ): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'setSpsApplicationEstimate'
      }, form.value
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  // 견적서 정보 가져오기
  getApplicationEstimate(seq: any): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'getApplicationEstimate'
      }, {seq: seq}
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

   // 시험검사신청서관리
   getInspectionNumbering(number_year: any): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'getInspectionNumbering'
      }, {number_year: number_year}
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

   // 시험검사 성정서 정보 수정
   setInspectionReport(form): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'setInspectionReport'
      }, form.value
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

   // 시험검사 성정서 정보 가져오기
   getInspectionReport(seq): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'getInspectionReport'
      }, {seq: seq}
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

   // 시험검사 성정서 정보 가져오기
   getInspectionPreview(seq): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'getInspectionPreview'
      }, {seq: seq}
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

   // 변경신청내역 정보 추가/수정
   setApplicationHistory(form): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'setApplicationHistory'
      }, form.value
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  // 변경신청내역 정보 가져오기
  getApplicationHistory(seq): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'getApplicationHistory'
      }, {seq: seq}
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  // 시험검사신청서 삭제하기 - 신청서에 포함된 모든 데이터 삭제
  deleteInspectionApplicationAllData(seq: any): Promise<any> {
    return this.restful.get({
      program: 'admin',
      service: 'inspectionApplication',
      version: '1.0',
      action: 'deleteInspectionApplicationAllData'
      }, {
        seq: seq
      }
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }  

  // 시험검사품목관리 삭제하기
  setDeleteHistory(seq: any): Promise<any> {
    return this.restful.get({
      program: 'admin',
      service: 'inspectionApplication',
      version: '1.0',
      action: 'setDeleteHistory'
      }, {
        seq: seq
      }
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  // 모델별 견적 저장하기
  setEstimateCalc(params): Promise<any> {
  return this.restful.post({
      program: 'admin',
      service: 'inspectionApplication',
      version: '1.0',
      action: 'setEstimateCalc'
    }, params
  ).then(this.extractData)
  .catch(this.handleErrorPromise);
  }

  // 모델별 항목 재설정
  setEstimateModel(params): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'setEstimateModel'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
    }

  // 실별시험장비사용비용 정보 가져오기
  getInspectionDeviceList(search): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'getLabUseFeeList'
      }, search
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 실별시험장비사용비용 정보 추가/수정
  setLabUseFee( form ): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'setLabUseFee'
      }, form.value
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  // 인증신청서 구비서류 삭제하기
  deleteLabUseFee(seq: any): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionbasic',
        version: '1.0',
        action: 'deleteLabUseFee'
      }, {seq: seq}
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

    // 실험실 리스트 가져오기
   getLabList(): Promise<any> {
      return this.restful.get({
          program: 'admin',
          service: 'inspectionbasic',
          version: '1.0',
          action: 'getLabList'
        }, {}
      ).then(this.extractData)
        .catch(this.handleErrorPromise);
    }

   // 실험실 사용신청서 등록 수정
   setLabUseApplication(params): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'setLabUseApplication'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  // 실험실 사용신청서 등록 수정
  setLabUseEstimate(params): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'setLabUseEstimate'
      }, params
    ).then(this.extractData)
    .catch(this.handleErrorPromise);
  }

  // 시험비용 견적서 출력
  getApplicationEstimateInfo(application_seq): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'getApplicationEstimateInfo'
      }, {application_seq}
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

  getApplicationComplain( params: any ): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'inspectionApplication',
        version: '1.0',
        action: 'getApplicationComplain'
      }, params
    ).then( response => {
      return response || [];
    })
     .catch(this.handleErrorPromise);
  }


}
